import { render } from "./profile-page.vue?vue&type=template&id=c7a443a4"
import script from "./profile-page.vue?vue&type=script&lang=js"
export * from "./profile-page.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__